import { openRoute, markers, viewportMarkers, clearViewportMarkers } from './index'
import { map } from '../map'
import createMarker from './createMarker'
import { MarkerClusterer } from '../marker-clusterer'
import renderResultList from '../result-list'
import removeLoader from '../utils/loader/removeLoader'
import createLoader from '../utils/loader/createLoader'
import paddedBounds from '../map/setPaddingToMap'
import { getParamByName } from '../utils/urlParamsControllers'
import bindAction from '../offers/bindAction'

window.loadedFromUrl = false

export const renderMarkers = opts => {
  let markerCluster = null

  google.maps.event.addListener(map, 'idle', () => {

    const toUrl = getParamByName('dest')
    if(toUrl !== null && !window.loadedFromUrl) {
      bindAction(toUrl)

      return
    }

    // add padding to map so markers beneath offers does not laod
    let paddedMapBounds = null
    let paddedOffsets = [10, 160, 10, 10]
    if(window.innerWidth <= 480) {
      paddedOffsets = [10, 10, 10, 10]
    }
    paddedMapBounds = paddedBounds(...paddedOffsets)

    // if route is opened, do nothing
    if(openRoute)
      return

    // markers reset in vewport so new can be added
    clearViewportMarkers()

    for (let i = 0; i < markers.length; i++) {
      const marker = createMarker(markers[i], opts.currency)
      
      if(paddedMapBounds.contains(marker.getPosition()))
        viewportMarkers.push(marker)
      // if(map.getBounds().contains(marker.getPosition()))
      //   viewportMarkers.push(marker)
    }

    const options = {
      imagePath: 'images/m'
    }

    if(markerCluster !== null)
      markerCluster.clearMarkers()

    markerCluster = new MarkerClusterer(map, viewportMarkers, options);
  })
}



// WEBPACK FOOTER //
// ./app/markers/renderMarkers.js